module.exports = __webpack_public_path__ + "static/media/TA273_0.be2f3840.png";